const POPUP_WIDTH = 500;
const POPUP_HEIGHT = 650;

type FrameContext = {
  self: unknown;
  top: unknown;
};

type PopupWindowContext = {
  screenX: number;
  outerWidth: number;
  screenY: number;
  outerHeight: number;
};

type IframePromptState = {
  isInIframe: boolean | null;
  isLoading: boolean;
  isAuthenticated: boolean;
};

export function isEmbeddedInIframe(frameContext: FrameContext): boolean {
  try {
    return frameContext.self !== frameContext.top;
  } catch {
    return true;
  }
}

export function buildPopupLoginUrl(origin: string): string {
  const popupCallbackUrl = `${origin}/auth/popup-callback`;
  return `/api/auth/login?returnTo=${encodeURIComponent(popupCallbackUrl)}`;
}

export function buildPopupWindowFeatures(context: PopupWindowContext): string {
  const left = context.screenX + (context.outerWidth - POPUP_WIDTH) / 2;
  const top = context.screenY + (context.outerHeight - POPUP_HEIGHT) / 2;

  return `width=${POPUP_WIDTH},height=${POPUP_HEIGHT},left=${left},top=${top},scrollbars=yes,resizable=yes`;
}

export function shouldShowIframeLoginPrompt(state: IframePromptState): boolean {
  return (
    state.isInIframe === true && !state.isLoading && !state.isAuthenticated
  );
}
